import {envUtil} from "@utils";
import CryptoJS, {AES, enc} from "crypto-js";

const common = {
  encryptQuery: ({query}: {query: string}) => {
    const encryptQuery = common.encrypt(query, envUtil.ENCRYPT_KEY);
    return encryptQuery;
  },

  decryptQuery: ({query}: {query: string}) => {
    const newQuery = query.replace(/[?]/gi, "");
    const decryptQuery = common.decrypt(newQuery, envUtil.ENCRYPT_KEY);
    return decryptQuery;
  },

  encryptCopyURL: ({query}: {query: string}) => {
    const encryptQuery = common.encrypt(query, envUtil.ENCRYPT_KEY);
    const url = `${"// TODO LINK"}/${encryptQuery}`;
    return url;
  },

  encrypt: (data: string, key: string): string => {
    const dataWA = enc.Utf8.parse(data);
    const keyWA = enc.Utf8.parse(key);
    const ivWA = enc.Utf8.parse(key.substring(0, 16));

    const cipher = AES.encrypt(dataWA, keyWA, {
      iv: ivWA,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    });
    const result = cipher.ciphertext.toString(enc.Base64url);
    return result;
  },

  decrypt: (encData: string, key: string): string => {
    const keyWA = enc.Utf8.parse(key);
    const ivWA = enc.Utf8.parse(key.substring(0, 16));

    const cipher = AES.decrypt(
      enc.Base64url.parse(encData.replace(/=/gi, "")).toString(enc.Base64),
      keyWA,
      {iv: ivWA, padding: CryptoJS.pad.Pkcs7, mode: CryptoJS.mode.CBC},
    );
    const result = cipher.toString(enc.Utf8);
    return result;
  },
};

export default common;
